module.exports = __webpack_public_path__ + "assets/img/ic-switch.f6757162.svg";